import * as queryString from 'query-string';
import API from '../api';
import * as actions from '../constants';
import generateActions from './baseAction';
import PAGINATE from '../../data/paginate';

const {
  showError,
  clearErrors,
  filterCompanies,
  getAllCompanies,
  getCompany,
  addCompany,
  updateCompany,
  removeCompany,

  requestGetCompanies,
  receiveGetCompanies,
  requestGetAllCompanies,
  receiveGetAllCompanies,
  requestGetCompany,
  receiveGetCompany,
  requestAddCompany,
  receiveAddCompany,
  requestUpdateCompany,
  receiveUpdateCompany,
  requestRemoveCompany,
  receiveRemoveCompany,
} = generateActions('company', 'companies');

/**
 * Search for a company
 * @param {String} name
 */
const searchCompanies = (name) => (dispatch) => {
  dispatch({ name, type: actions.REQUEST_SEARCH_COMPANIES });
  const query: any = { name };
  return API.request(`/companies/search/?${queryString.stringify(query)}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: actions.RECEIVE_SEARCH_COMPANIES });
      return response;
    })
    .catch((err) => {
      dispatch({ type: actions.RECEIVE_SEARCH_COMPANIES });
      return false;
    });
};

const getRevision = (companyId, revisionId) => (dispatch) => {
  return API.request(`/companies/${companyId}/revision/${revisionId}`)
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
};

/**
 * Get the bookings related to the company
 * @param {Number} id
 * @param {Number} offset
 * @param {Number} limit
 */
const getCompanyBookings = (
  id,
  offset = 0,
  limit = PAGINATE.bookingRelations.MAX,
) => (dispatch) => {
  dispatch({ type: actions.REQUEST_DRIVER_BOOKINGS });
  return API.request(
    `/companies/${id}/bookings?${queryString.stringify({
      offset,
      limit,
    })}`,
  )
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: actions.RECEIVE_COMPANY_BOOKINGS });
      return response;
    })
    .catch((err) => {
      dispatch({ type: actions.RECEIVE_COMPANY_BOOKINGS });
      return false;
    });
};

const getCompanies = (
  date = new Date(),
  page: number = 0,
  search: string = '',
  limit: number = PAGINATE.companies.MAX,
) => (dispatch) => {
  dispatch(requestGetCompanies());
  return API.request(`/companies?page=${page}&limit=${limit}&search=${search}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch(receiveGetCompanies(response.error, response.data, date));
      return response;
    });
};

/**
 * Request the payments associated with the company
 */
const getCompanyPayments = ({
  id = 0,
  page = 0,
  limit = PAGINATE.payments.MAX,
  order,
  sort,
}) => (dispatch) => {
  const query = {
    page,
    limit,
    order,
    sort,
  };
  dispatch({
    type: actions.REQUEST_COMPANY_PAYMENTS,
  });
  return API.request(
    `/companies/${id}/payments?${queryString.stringify(query)}`,
  )
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        response,
        type: actions.RECEIVE_COMPANY_PAYMENTS,
      });
      return response;
    });
};

/**
 * Merge a list of companies into one
 */
const mergeCompanies = (companyIds, overrides?) => async (dispatch) => {
  dispatch({
    type: actions.REQUEST_MERGE_COMPANIES,
  });
  const response = await (await API.request('/companies/merge', 'POST', {
    overrides: JSON.stringify(overrides),
    companyIds: JSON.stringify(companyIds),
  })).json();
  dispatch({
    data: response.data,
    error: response.error,
    type: actions.RECEIVE_MERGE_COMPANIES,
  });
  return response;
};

export {
  addCompany,
  clearErrors,
  filterCompanies,
  getAllCompanies,
  getCompanies,
  getCompany,
  getCompanyBookings,
  getCompanyPayments,
  mergeCompanies,
  receiveAddCompany,
  receiveGetAllCompanies,
  receiveGetCompanies,
  receiveGetCompany,
  receiveRemoveCompany,
  receiveUpdateCompany,
  removeCompany,
  requestAddCompany,
  requestGetAllCompanies,
  requestGetCompanies,
  requestGetCompany,
  requestRemoveCompany,
  requestUpdateCompany,
  searchCompanies,
  showError,
  updateCompany,
  getRevision,
};
